import {GET_CHAT} from '../data/chat_data'
import {ADD_TO_CHAT,DELETE_MASS,MARK_CHAT_DELIVERED} from './actions'
import ChatModel from '../model/chat'
const initialState = {
  chats:[],
  userinfo:{}
}

export default (state=initialState,actions) =>{
  switch (actions.type) {
    case GET_CHAT:
      return{
        chats: (actions.data || []).map(chat => {
          const prev = state.chats.find(item => String(item.id) === String(chat.id));
          if (prev?.status === 'delivered' && chat.status !== 'delivered') {
            return new ChatModel(chat.id, chat.fromm, chat.to, chat.text, chat.date, 'delivered');
          }
          return chat;
        }),
        userinfo:actions.info
      }
    case ADD_TO_CHAT:
     const data = actions.Data;
     const newChat = new ChatModel(data.id || new Date().toString(),data.fromm,data.to,data.text,data.date,data.status);
     if (state.chats.some(chat => String(chat.id) === String(newChat.id))) return state;
     return{
       ...state,chats:state.chats.concat(newChat)
     }
    case MARK_CHAT_DELIVERED: {
      const delivered = new Set((actions.ids || []).map(String));
      return {
        ...state,
        chats: state.chats.map(chat =>
          delivered.has(String(chat.id))
            ? new ChatModel(chat.id, chat.fromm, chat.to, chat.text, chat.date, 'delivered')
            : chat
        )
      };
    }
     case DELETE_MASS:
     return{
       ...state,
        chats:state.chats.filter(prod => prod.id !== actions.id)

     }

  }
  return state;
}
